import { render, staticRenderFns } from "./IntroContent.vue?vue&type=template&id=a9cf868c"
import script from "./IntroContent.vue?vue&type=script&lang=js"
export * from "./IntroContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports